import React, { useEffect, useMemo, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api';
import { useAuth } from '../AuthContext';
import { useTheme } from '../contexts/ThemeContext';

const TR = (s: string) =>
  new Date(s).toLocaleDateString('tr-TR', { day: '2-digit', month: 'short', year: 'numeric' });
const SAAT = (s: string) =>
  new Date(s).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });

const DURUMLAR = [
  { key: 'yeni',        label: 'Yeni',         renk: '#534AB7', bg: '#EEEDFE' },
  { key: 'iletisimde',  label: 'İletişimde',   renk: '#0C447C', bg: '#E6F1FB' },
  { key: 'ilgileniyor', label: 'İlgileniyor',  renk: '#854F0B', bg: '#FAEEDA' },
  { key: 'deneme',      label: 'Deneme',       renk: '#3B6D11', bg: '#EAF3DE' },
  { key: 'kayit_oldu',  label: 'Kayıt Oldu',  renk: '#085041', bg: '#C8F0E4' },
  { key: 'vazgecti',    label: 'Vazgeçti',     renk: '#888',    bg: '#f0f0f0' },
] as const;

const KAYNAKLAR = [
  { key: 'instagram', label: 'Instagram' }, { key: 'whatsapp', label: 'WhatsApp' },
  { key: 'email', label: 'E-posta' },       { key: 'website', label: 'Web sitesi' },
  { key: 'referans', label: 'Referans' },   { key: 'telefon', label: 'Telefon' },
  { key: 'diger', label: 'Diğer' },
];

const KANALLAR = [
  { key: 'whatsapp',  label: 'WhatsApp',   icon: '💬' },
  { key: 'telefon',   label: 'Telefon',    icon: '📞' },
  { key: 'email',     label: 'E-posta',    icon: '✉' },
  { key: 'instagram', label: 'Instagram',  icon: '📸' },
  { key: 'yuz_yuze',  label: 'Yüz yüze',  icon: '🤝' },
  { key: 'diger',     label: 'Diğer',      icon: '•' },
];

const durumBul = (key: string) => DURUMLAR.find(d => d.key === key) ?? DURUMLAR[0];
const kanalBul = (key: string) => KANALLAR.find(k => k.key === key) ?? KANALLAR[5];

const ETIKET_RENKLERI = ['#534AB7', '#0C447C', '#854F0B', '#3B6D11', '#B45309', '#A32D2D', '#0F766E', '#7C3AED'];
function etiketRenk(ad: string) {
  let h = 0;
  for (let i = 0; i < ad.length; i++) h = (h * 31 + ad.charCodeAt(i)) >>> 0;
  return ETIKET_RENKLERI[h % ETIKET_RENKLERI.length];
}

interface Aday {
  id: string; ad: string; soyad: string; email: string; tel: string;
  kaynak: string; durum: string; ilgi_alani: string; notlar: string;
  cinsiyet: string | null; ogrenci_id: string | null; olusturuldu: string;
  sube_id?: string; sube_adi?: string;
  ilgilenilen_ders_id?: string | null; ilgilenilen_ders_adi?: string | null; ilgilenilen_ders_seviye?: string | null;
  etiketler?: { id: string; ad: string }[];
}
interface Ders { id: string; ad: string; seviye: string; sube_id?: string; aktif: boolean; }
interface Etiket { id: string; ad: string; sube_id?: string | null; kullanim_sayisi: number; }
interface Gorusme {
  id: string; kanal: string; icerik: string; olusturuldu: string;
}
interface Alarm {
  id: string; tarih: string; saat: string | null; baslik: string; notlar: string | null; tamamlandi: boolean;
}

export default function CRMAday() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { kullanici, subeGirisi } = useAuth();
  const isAdmin = ['super_admin','sube_admin','admin'].includes(kullanici?.rol ?? '');
  const isSuperAdmin = kullanici?.rol === 'super_admin' || subeGirisi !== null;
  const { isDark } = useTheme();
  const card        = isDark ? '#1a1a1a' : 'white';
  const cardAlt     = isDark ? '#1e1e1e' : '#f8f8f8';
  const cardHover   = isDark ? '#252525' : '#fafafa';
  const border      = isDark ? '#2a2a2a' : '#eee';
  const textPrimary = isDark ? '#e8e8e8' : '#1a1a1a';
  const textSec     = isDark ? '#999'    : '#888';
  const textMuted   = isDark ? '#666'    : '#aaa';

  const [aday, setAday] = useState<Aday | null>(null);
  const [gorusmeler, setGorusmeler] = useState<Gorusme[]>([]);
  const [alarmlar, setAlarmlar] = useState<Alarm[]>([]);
  const [yukleniyor, setYukleniyor] = useState(true);

  // WhatsApp yazışma
  const [waMesajlar, setWaMesajlar] = useState<any[]>([]);
  const [waYukleniyor, setWaYukleniyor] = useState(false);
  const [waYaziliyor, setWaYaziliyor] = useState(false);
  const [waMetin, setWaMetin] = useState('');
  const [waGonderiliyor, setWaGonderiliyor] = useState(false);

  const [yonlendirModal, setYonlendirModal] = useState(false);
  const [subeler, setSubeler] = useState<{ id: string; ad: string }[]>([]);
  const [hedefSubeId, setHedefSubeId] = useState('');
  const [yonlendirNot, setYonlendirNot] = useState('');
  const [yonlendiriliyor, setYonlendiriliyor] = useState(false);

  const [duzenleModal, setDuzenleModal] = useState(false);
  const [form, setForm] = useState<any>({});
  const [dersler, setDersler] = useState<Ders[]>([]);
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [hata, setHata] = useState('');

  const [yeniGorusmeKanal, setYeniGorusmeKanal] = useState('whatsapp');
  const [yeniGorusmeIcerik, setYeniGorusmeIcerik] = useState('');
  const [gorusmeEkleniyor, setGorusmeEkleniyor] = useState(false);

  const [alarmModal, setAlarmModal] = useState(false);
  const [alarmForm, setAlarmForm] = useState({ tarih: '', saat: '', baslik: '', notlar: '' });
  const [alarmEkleniyor, setAlarmEkleniyor] = useState(false);

  const [donusturuluyor, setDonusturuluyor] = useState(false);

  // Mevcut öğrenciyle birleştir (yanlış kayıt düzeltme)
  const [birlestirModal, setBirlestirModal] = useState(false);
  const [ogrenciArama, setOgrenciArama] = useState('');
  const [ogrencilerSonuc, setOgrencilerSonuc] = useState<any[]>([]);
  const [aramaYukleniyor, setAramaYukleniyor] = useState(false);
  const [secilenOgrenci, setSecilenOgrenci] = useState<any>(null);
  const [birlestirYapiliyor, setBirlestirYapiliyor] = useState(false);

  const BUGUN = new Date().toISOString().slice(0, 10);

  const yukle = async () => {
    if (!id) return;
    setYukleniyor(true);
    try {
      const [detayRes, alarmRes] = await Promise.all([
        api.get(`/api/crm/adaylar/${id}`),
        api.get('/api/crm/alarmlar'),
      ]);
      setAday(detayRes.data.aday);
      setGorusmeler(detayRes.data.gorusmeler);
      setAlarmlar(alarmRes.data.filter((a: any) => a.aday_id === id));
    } catch (e) { console.error(e); }
    finally { setYukleniyor(false); }
  };

  useEffect(() => { yukle(); }, [id]);

  useEffect(() => { api.get('/api/dersler').then(r => setDersler(r.data)).catch(() => {}); }, []);
  // Adayın kendi şubesindeki dersler — süper adminler farklı şubelerdeki adayları
  // görebildiği için sayfa-geneli bir filtre yerine adayın gerçek sube_id'sine göre daraltılır
  const dersOptions = useMemo(
    () => dersler.filter(d => !aday?.sube_id || d.sube_id === aday.sube_id),
    [dersler, aday?.sube_id]
  );

  // Gruplar (etiketler) — adayın kendi şubesine göre
  const [etiketler, setEtiketler] = useState<Etiket[]>([]);
  const [etiketPanelAcik, setEtiketPanelAcik] = useState(false);
  const [yeniEtiketAd, setYeniEtiketAd] = useState('');
  const [etiketIsleniyor, setEtiketIsleniyor] = useState(false);
  useEffect(() => {
    api.get('/api/crm/etiketler', { params: aday?.sube_id ? { sube_id: aday.sube_id } : {} })
      .then(r => setEtiketler(r.data)).catch(() => {});
  }, [aday?.sube_id]);

  const etiketEkle = async (etiket_id: string) => {
    try { await api.post(`/api/crm/adaylar/${id}/etiketler`, { etiket_id }); yukle(); }
    catch (e: any) { alert(e.response?.data?.hata || 'Eklenemedi'); }
  };
  const etiketCikar = async (etiket_id: string) => {
    try { await api.delete(`/api/crm/adaylar/${id}/etiketler/${etiket_id}`); yukle(); }
    catch (e: any) { alert(e.response?.data?.hata || 'Kaldırılamadı'); }
  };
  const yeniEtiketOlusturVeEkle = async () => {
    if (!yeniEtiketAd.trim()) return;
    setEtiketIsleniyor(true);
    try {
      const r = await api.post('/api/crm/etiketler', { ad: yeniEtiketAd.trim() });
      setEtiketler(p => [...p, r.data].sort((a, b) => a.ad.localeCompare(b.ad, 'tr')));
      await etiketEkle(r.data.id);
      setYeniEtiketAd(''); setEtiketPanelAcik(false);
    } catch (e: any) { alert(e.response?.data?.hata || 'Grup eklenemedi'); }
    finally { setEtiketIsleniyor(false); }
  };

  const waYukle = async () => {
    if (!id) return;
    setWaYukleniyor(true);
    try {
      const r = await api.get(`/api/whatsapp/mesajlar/${id}`);
      setWaMesajlar(r.data);
    } catch { /* henüz mesaj yok */ }
    finally { setWaYukleniyor(false); }
  };

  const waGonder = async () => {
    if (!waMetin.trim() || !aday?.tel) return;
    setWaGonderiliyor(true);
    try {
      await api.post('/api/whatsapp/gonder', {
        aday_id: id,
        telefon: aday.tel.replace(/\D/g, ''),
        icerik: waMetin.trim(),
      });
      setWaMetin('');
      waYukle();
    } catch (err: any) {
      alert(err.response?.data?.hata || 'Gönderilemedi');
    } finally { setWaGonderiliyor(false); }
  };

  const duzenleAc = () => {
    if (!aday) return;
    setForm({ ad: aday.ad, soyad: aday.soyad||'', email: aday.email||'', tel: aday.tel||'', kaynak: aday.kaynak, durum: aday.durum, ilgi_alani: aday.ilgi_alani||'', notlar: aday.notlar||'', cinsiyet: aday.cinsiyet||'', ilgilenilen_ders_id: aday.ilgilenilen_ders_id||'' });
    setHata('');
    setDuzenleModal(true);
  };

  const duzenleKaydet = async () => {
    if (!form.ad?.trim()) { setHata('Ad zorunlu'); return; }
    setKaydediliyor(true); setHata('');
    try {
      await api.put(`/api/crm/adaylar/${id}`, form);
      setDuzenleModal(false);
      yukle();
    } catch (e: any) { setHata(e.response?.data?.hata ?? 'Hata'); }
    finally { setKaydediliyor(false); }
  };

  const durumDegistir = async (yeniDurum: string) => {
    if (!aday) return;
    try {
      const res = await api.put(`/api/crm/adaylar/${id}`, { ...aday, durum: yeniDurum });
      if (res.data?._uyari) alert(res.data._uyari);
      else if (res.data?._ogrenci?.mevcut === false) alert('Öğrenci kaydı oluşturuldu ve karta bağlandı.');
      else if (res.data?._ogrenci?.mevcut === true) alert('Mevcut öğrenci kaydıyla eşleştirildi.');
      yukle();
    } catch (e) { console.error(e); }
  };

  const gorusmeEkle = async () => {
    if (!yeniGorusmeIcerik.trim()) return;
    setGorusmeEkleniyor(true);
    try {
      await api.post(`/api/crm/adaylar/${id}/gorusmeler`, { kanal: yeniGorusmeKanal, icerik: yeniGorusmeIcerik.trim() });
      setYeniGorusmeIcerik('');
      yukle();
    } catch (e) { console.error(e); }
    finally { setGorusmeEkleniyor(false); }
  };

  const alarmEkle = async () => {
    if (!alarmForm.tarih || !alarmForm.baslik.trim()) return;
    setAlarmEkleniyor(true);
    try {
      await api.post(`/api/crm/adaylar/${id}/alarmlar`, alarmForm);
      setAlarmModal(false);
      setAlarmForm({ tarih: '', saat: '', baslik: '', notlar: '' });
      yukle();
    } catch (e) { console.error(e); }
    finally { setAlarmEkleniyor(false); }
  };

  const alarmTamamla = async (alarmId: string, tamamlandi: boolean) => {
    try {
      await api.patch(`/api/crm/alarmlar/${alarmId}/tamamla`, { tamamlandi });
      yukle();
    } catch (e) { console.error(e); }
  };

  const alarmSil = async (alarmId: string) => {
    try {
      await api.delete(`/api/crm/alarmlar/${alarmId}`);
      yukle();
    } catch (e) { console.error(e); }
  };

  const yonlendirAc = async () => {
    if (!subeler.length) {
      const r = await api.get('/api/subeler');
      setSubeler(r.data.filter((s: any) => s.id !== aday?.sube_id));
    }
    setHedefSubeId(''); setYonlendirNot('');
    setYonlendirModal(true);
  };

  const yonlendir = async () => {
    if (!hedefSubeId) return;
    setYonlendiriliyor(true);
    try {
      const r = await api.post(`/api/crm/adaylar/${id}/yonlendir`, { hedef_sube_id: hedefSubeId, not: yonlendirNot });
      setYonlendirModal(false);
      alert(`✓ ${r.data.hedef_adi} şubesine yönlendirildi`);
      navigate('/crm');
    } catch (e: any) { alert(e.response?.data?.hata ?? 'Hata'); }
    finally { setYonlendiriliyor(false); }
  };

  const ogrenciyeDonustur = async () => {
    if (!aday?.email) {
      alert('Öğrenciye dönüştürmeden önce lütfen e-posta adresini girin.\n\nGoogle ile giriş yapabilmesi için e-posta zorunludur.');
      setDuzenleModal(true);
      return;
    }
    if (!window.confirm(`${aday?.ad} ${aday?.soyad ?? ''} öğrenci olarak sisteme eklensin mi?`)) return;
    setDonusturuluyor(true);
    try {
      const res = await api.post(`/api/crm/adaylar/${id}/kayit-et`);
      if (res.data.mevcut) {
        alert('Mevcut öğrenci hesabıyla eşleştirildi.');
      } else if (!aday?.email) {
        alert('Öğrenci kaydı oluşturuldu.\n\nNot: E-posta adresi girilmemiş, lütfen öğrenci profilinden güncelleyin.');
      }
      navigate(`/ogrenciler/${res.data.ogrenci_id}`);
    } catch (e: any) { alert(e.response?.data?.hata ?? 'Hata'); }
    finally { setDonusturuluyor(false); }
  };

  const adaySil = async () => {
    if (!window.confirm(`${aday?.ad} ${aday?.soyad ?? ''} adlı CRM kaydı kalıcı olarak silinecek. Emin misiniz?`)) return;
    try {
      await api.delete(`/api/crm/adaylar/${id}`);
      navigate('/crm');
    } catch (e: any) { alert(e.response?.data?.hata ?? 'Silinemedi'); }
  };

  const ogrenciAra = async (q: string) => {
    if (!q.trim()) { setOgrencilerSonuc([]); return; }
    setAramaYukleniyor(true);
    try {
      const r = await api.get(`/api/ogrenciler?arama=${encodeURIComponent(q)}&tum=true`);
      setOgrencilerSonuc(r.data);
    } catch {} finally { setAramaYukleniyor(false); }
  };

  const birlestirGonder = async () => {
    if (!secilenOgrenci || !aday?.email) return;
    if (!window.confirm(`"${aday.ad} ${aday.soyad ?? ''}" adlı kişinin mobil hesabı (${aday.email}) mevcut öğrenci "${secilenOgrenci.ad} ${secilenOgrenci.soyad}" ile birleştirilecek. Onaylıyor musunuz?`)) return;
    setBirlestirYapiliyor(true);
    try {
      await api.post(`/api/ogrenciler/${secilenOgrenci.id}/birlestir-talep`, { yeni_email: aday.email });
      await api.post(`/api/crm/adaylar/${id}/ogrenciye-bagla`, { ogrenci_id: secilenOgrenci.id });
      alert('Birleştirme tamamlandı.');
      navigate(`/ogrenciler/${secilenOgrenci.id}`);
    } catch (e: any) { alert(e.response?.data?.hata ?? 'Birleştirme başarısız'); }
    finally { setBirlestirYapiliyor(false); }
  };

  if (yukleniyor) return <div style={{ padding: 40, textAlign: 'center', color: textMuted }}>Yükleniyor...</div>;
  if (!aday) return <div style={{ padding: 24, color: textMuted }}>Aday bulunamadı.</div>;

  const dur = durumBul(aday.durum);
  const kaynak = KAYNAKLAR.find(k => k.key === aday.kaynak);

  return (
    <div style={{ padding: '24px 24px 48px', maxWidth: 820, margin: '0 auto' }}>

      {/* Geri */}
      <button onClick={() => navigate(-1)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: textSec, fontSize: 13, padding: '0 0 16px', display: 'flex', alignItems: 'center', gap: 6 }}>
        ← Geri
      </button>

      {/* Profil kartı */}
      <div style={{ background: card, border: `1px solid ${border}`, borderRadius: 12, padding: 24, marginBottom: 16 }}>
        <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start', flexWrap: 'wrap' }}>
          {/* Avatar */}
          <div style={{ width: 64, height: 64, borderRadius: '50%', background: dur.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, fontWeight: 700, color: dur.renk, flexShrink: 0 }}>
            {aday.ad?.charAt(0)}{aday.soyad?.charAt(0) ?? ''}
          </div>

          <div style={{ flex: 1, minWidth: 200 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 6 }}>
              <h1 style={{ fontSize: 20, fontWeight: 700, margin: 0 }}>{aday.ad} {aday.soyad}</h1>
              <span style={{ background: dur.bg, color: dur.renk, borderRadius: 20, padding: '3px 12px', fontSize: 12, fontWeight: 600 }}>{dur.label}</span>
              {kaynak && <span style={{ background: isDark ? '#222222' : '#f0f0f0', color: isDark ? '#999' : '#666', borderRadius: 20, padding: '3px 10px', fontSize: 11 }}>{kaynak.label}</span>}
            </div>
            <div style={{ fontSize: 13, color: textSec, display: 'flex', gap: 16, flexWrap: 'wrap' }}>
              {aday.email && <span>✉ {aday.email}</span>}
              {aday.tel   && <span>📱 {aday.tel}</span>}
              {aday.ilgilenilen_ders_adi && <span>🏫 {aday.ilgilenilen_ders_adi} · {aday.ilgilenilen_ders_seviye}</span>}
              {aday.ilgi_alani && <span>🎯 {aday.ilgi_alani}</span>}
            </div>
            {aday.notlar && (
              <div style={{ marginTop: 8, fontSize: 13, color: isDark ? '#bbb' : '#555', background: cardHover, borderRadius: 6, padding: '6px 10px', lineHeight: 1.6 }}>
                {aday.notlar}
              </div>
            )}

            {/* Gruplar */}
            <div style={{ marginTop: 12 }}>
              <div style={{ fontSize: 11, color: textMuted, fontWeight: 600, marginBottom: 6, textTransform: 'uppercase', letterSpacing: 0.3 }}>Gruplar</div>
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center', position: 'relative' }}>
                {aday.etiketler?.map(e => (
                  <span key={e.id} style={{ display: 'flex', alignItems: 'center', gap: 5, background: etiketRenk(e.ad) + '22', color: etiketRenk(e.ad), borderRadius: 20, padding: '4px 8px 4px 12px', fontSize: 12, fontWeight: 600 }}>
                    🏷️ {e.ad}
                    <button onClick={() => etiketCikar(e.id)} title="Gruptan çıkar"
                      style={{ border: 'none', background: 'none', color: 'inherit', cursor: 'pointer', fontSize: 14, padding: 0, lineHeight: 1, opacity: 0.7 }}>
                      ×
                    </button>
                  </span>
                ))}
                <button onClick={() => setEtiketPanelAcik(p => !p)}
                  style={{ border: '1.5px solid #534AB7', background: isDark ? 'rgba(83,74,183,0.15)' : '#EEEDFE', color: '#534AB7', borderRadius: 20, padding: '5px 14px', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>
                  + Grup Ekle
                </button>
              {etiketPanelAcik && (
                <div style={{ position: 'absolute', top: '100%', left: 0, marginTop: 6, background: card, border: `1px solid ${border}`, borderRadius: 8, padding: 10, width: 240, zIndex: 50, boxShadow: '0 4px 16px rgba(0,0,0,0.15)' }}>
                  <div style={{ display: 'grid', gap: 4, maxHeight: 160, overflowY: 'auto', marginBottom: 8 }}>
                    {etiketler.filter(e => !aday.etiketler?.some(ae => ae.id === e.id)).map(e => (
                      <button key={e.id} onClick={() => { etiketEkle(e.id); setEtiketPanelAcik(false); }}
                        style={{ textAlign: 'left', border: 'none', background: cardHover, color: etiketRenk(e.ad), borderRadius: 6, padding: '5px 8px', fontSize: 12, cursor: 'pointer', fontWeight: 600 }}>
                        {e.ad}
                      </button>
                    ))}
                    {etiketler.length === 0 && <div style={{ fontSize: 11, color: textMuted }}>Henüz grup yok.</div>}
                  </div>
                  <div style={{ display: 'flex', gap: 4 }}>
                    <input value={yeniEtiketAd} onChange={e => setYeniEtiketAd(e.target.value)}
                      onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); yeniEtiketOlusturVeEkle(); } }}
                      placeholder="Yeni grup..." style={{ flex: 1, padding: '5px 8px', borderRadius: 5, border: `1px solid ${border}`, fontSize: 12 }} />
                    <button onClick={yeniEtiketOlusturVeEkle} disabled={etiketIsleniyor || !yeniEtiketAd.trim()}
                      style={{ border: 'none', background: '#534AB7', color: 'white', borderRadius: 5, padding: '0 10px', fontSize: 12, cursor: 'pointer', opacity: !yeniEtiketAd.trim() ? 0.5 : 1 }}>
                      +
                    </button>
                  </div>
                </div>
              )}
              </div>
            </div>
          </div>

          <div style={{ display: 'flex', gap: 8, flexShrink: 0, flexWrap: 'wrap' }}>
            {/* Şube badge */}
            {aday.sube_adi && (
              <span style={{ alignSelf: 'center', background: '#EEF2FF', color: '#6366F1', borderRadius: 20, padding: '4px 12px', fontSize: 11, fontWeight: 700 }}>
                🏢 {aday.sube_adi}
              </span>
            )}
            <button onClick={duzenleAc}
              style={{ border: `1px solid ${border}`, background: card, borderRadius: 8, padding: '7px 14px', fontSize: 12, cursor: 'pointer', color: '#534AB7' }}>
              ✎ Düzenle
            </button>
            {isSuperAdmin && (
              <button onClick={adaySil}
                style={{ border: '1px solid #E24B4A', background: card, color: '#E24B4A', borderRadius: 8, padding: '7px 14px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                🗑 Sil
              </button>
            )}
            {isAdmin && aday.durum !== 'kayit_oldu' && (
              <button onClick={yonlendirAc}
                style={{ border: '1px solid #6366F1', background: card, color: '#6366F1', borderRadius: 8, padding: '7px 14px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                🔀 Şubeye Yönlendir
              </button>
            )}
            {(aday.durum !== 'kayit_oldu' || !aday.ogrenci_id) && aday.kaynak === 'mobile_basvuru' && aday.email && (
              <button onClick={() => { setBirlestirModal(true); setOgrenciArama(''); setOgrencilerSonuc([]); setSecilenOgrenci(null); }}
                style={{ border: '1px solid #534AB7', background: card, color: '#534AB7', borderRadius: 8, padding: '7px 14px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                ⇌ Mevcut öğrenciyle birleştir
              </button>
            )}
            {(aday.durum !== 'kayit_oldu' || !aday.ogrenci_id) && (
              <button onClick={ogrenciyeDonustur} disabled={donusturuluyor}
                style={{ border: 'none', background: '#1D9E75', color: 'white', borderRadius: 8, padding: '7px 16px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                {donusturuluyor ? '...' : '✓ Öğrenciye dönüştür'}
              </button>
            )}
            {aday.durum === 'kayit_oldu' && aday.ogrenci_id && (
              <button onClick={() => navigate(`/ogrenciler/${aday.ogrenci_id}`)}
                style={{ border: 'none', background: '#C8F0E4', color: '#085041', borderRadius: 8, padding: '7px 14px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                → Öğrenci profiline git
              </button>
            )}
          </div>
        </div>

        {/* Durum ilerlemesi */}
        {aday.durum !== 'vazgecti' && (
          <div style={{ marginTop: 20, display: 'flex', gap: 4, alignItems: 'center' }}>
            {(['yeni', 'iletisimde', 'ilgileniyor', 'deneme', 'kayit_oldu'] as const).map((d, i) => {
              const dur2 = durumBul(d);
              const adimlar = ['yeni', 'iletisimde', 'ilgileniyor', 'deneme', 'kayit_oldu'];
              const mevcutIdx = adimlar.indexOf(aday.durum);
              const buIdx = adimlar.indexOf(d);
              const gecti = buIdx <= mevcutIdx;
              const aktif = d === aday.durum;
              return (
                <React.Fragment key={d}>
                  {i > 0 && <div style={{ flex: 1, height: 2, background: gecti ? dur2.renk : border, transition: 'background .3s' }} />}
                  <button
                    onClick={() => durumDegistir(d)}
                    title={dur2.label}
                    style={{
                      padding: '4px 12px', borderRadius: 20, border: `1.5px solid ${gecti ? dur2.renk : '#ddd'}`,
                      background: aktif ? dur2.bg : gecti ? dur2.bg : card,
                      color: gecti ? dur2.renk : textMuted, fontSize: 11, fontWeight: aktif ? 700 : 400,
                      cursor: 'pointer', whiteSpace: 'nowrap' as const, flexShrink: 0,
                    }}>
                    {dur2.label}
                  </button>
                </React.Fragment>
              );
            })}
            <div style={{ flex: 1, height: 2, background: border }} />
            <button onClick={() => durumDegistir('vazgecti')}
              style={{ padding: '4px 12px', borderRadius: 20, border: '1.5px solid #ddd', background: card, color: textMuted, fontSize: 11, cursor: 'pointer', flexShrink: 0 }}>
              Vazgeçti
            </button>
          </div>
        )}
        {aday.durum === 'vazgecti' && (
          <div style={{ marginTop: 12 }}>
            <button onClick={() => durumDegistir('yeni')}
              style={{ border: `1px solid ${border}`, background: card, borderRadius: 6, padding: '5px 12px', fontSize: 12, cursor: 'pointer', color: '#534AB7' }}>
              ↩ Yeniden aktif et
            </button>
          </div>
        )}
      </div>

      {/* Görüşme ekle */}
      <div style={{ background: card, border: `1px solid ${border}`, borderRadius: 12, padding: 20, marginBottom: 16 }}>
        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 12 }}>Görüşme ekle</div>
        <div style={{ display: 'flex', gap: 8, marginBottom: 10, flexWrap: 'wrap' }}>
          {KANALLAR.map(k => (
            <button key={k.key} onClick={() => setYeniGorusmeKanal(k.key)}
              style={{
                padding: '5px 12px', borderRadius: 20, border: `1.5px solid ${yeniGorusmeKanal === k.key ? '#534AB7' : border}`,
                background: yeniGorusmeKanal === k.key ? '#EEEDFE' : card,
                color: yeniGorusmeKanal === k.key ? '#534AB7' : textSec,
                cursor: 'pointer', fontSize: 12,
              }}>
              {k.icon} {k.label}
            </button>
          ))}
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <textarea
            value={yeniGorusmeIcerik}
            onChange={e => setYeniGorusmeIcerik(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) gorusmeEkle(); }}
            placeholder="Görüşme notu... (Ctrl+Enter ile kaydet)"
            rows={3}
            style={{ flex: 1, padding: '8px 12px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13, resize: 'vertical' as const, fontFamily: 'sans-serif' }}
          />
          <button onClick={gorusmeEkle} disabled={gorusmeEkleniyor || !yeniGorusmeIcerik.trim()}
            style={{ padding: '0 18px', borderRadius: 8, border: 'none', background: '#534AB7', color: 'white', cursor: 'pointer', fontSize: 13, fontWeight: 600, opacity: !yeniGorusmeIcerik.trim() ? .4 : 1, alignSelf: 'stretch' }}>
            {gorusmeEkleniyor ? '...' : 'Kaydet'}
          </button>
        </div>
      </div>

      {/* Alarmlar */}
      <div style={{ background: card, border: `1px solid ${border}`, borderRadius: 12, padding: 20, marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
          <div style={{ fontSize: 13, fontWeight: 600 }}>
            🔔 Hatırlatıcılar
            {alarmlar.filter(a => !a.tamamlandi).length > 0 && (
              <span style={{ marginLeft: 8, background: isDark ? 'rgba(245,158,11,0.15)' : '#FAEEDA', color: '#854F0B', borderRadius: 20, padding: '1px 8px', fontSize: 11, fontWeight: 700 }}>
                {alarmlar.filter(a => !a.tamamlandi).length} aktif
              </span>
            )}
          </div>
          <button onClick={() => { setAlarmForm({ tarih: '', saat: '', baslik: '', notlar: '' }); setAlarmModal(true); }}
            style={{ border: `1px solid ${border}`, background: card, borderRadius: 6, padding: '5px 12px', fontSize: 12, cursor: 'pointer', color: '#534AB7', fontWeight: 600 }}>
            + Hatırlatıcı ekle
          </button>
        </div>

        {alarmlar.length === 0 ? (
          <div style={{ color: textMuted, fontSize: 13, textAlign: 'center', padding: '16px 0' }}>Henüz hatırlatıcı yok.</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {alarmlar.map(al => {
              const gecti = !al.tamamlandi && al.tarih < BUGUN;
              const bugun = al.tarih === BUGUN;
              return (
                <div key={al.id} style={{
                  display: 'flex', alignItems: 'flex-start', gap: 12, padding: '10px 12px', borderRadius: 8,
                  background: al.tamamlandi ? cardHover : gecti ? (isDark ? 'rgba(228,75,74,0.08)' : '#FFF3F3') : bugun ? (isDark ? 'rgba(245,158,11,0.08)' : '#FFFBEA') : (isDark ? '#1c1c2e' : '#f8f8ff'),
                  border: `1px solid ${al.tamamlandi ? border : gecti ? (isDark ? 'rgba(228,75,74,0.3)' : '#FACACA') : bugun ? (isDark ? 'rgba(245,158,11,0.3)' : '#FFE58F') : (isDark ? 'rgba(83,74,183,0.3)' : '#EEEDFE')}`,
                  opacity: al.tamamlandi ? .6 : 1,
                }}>
                  <input type="checkbox" checked={al.tamamlandi} onChange={e => alarmTamamla(al.id, e.target.checked)}
                    style={{ marginTop: 2, cursor: 'pointer', width: 15, height: 15, flexShrink: 0 }} />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                      <span style={{ fontSize: 13, fontWeight: 600, textDecoration: al.tamamlandi ? 'line-through' : 'none', color: al.tamamlandi ? textMuted : isDark ? '#e0e0e0' : '#333' }}>
                        {al.baslik}
                      </span>
                      {gecti && !al.tamamlandi && <span style={{ background: isDark ? 'rgba(228,75,74,0.15)' : '#FCEBEB', color: '#A32D2D', borderRadius: 20, padding: '1px 8px', fontSize: 10, fontWeight: 700 }}>Geçti!</span>}
                      {bugun && !al.tamamlandi && <span style={{ background: isDark ? 'rgba(245,158,11,0.15)' : '#FFF3CD', color: '#856404', borderRadius: 20, padding: '1px 8px', fontSize: 10, fontWeight: 700 }}>Bugün</span>}
                    </div>
                    <div style={{ fontSize: 11, color: textSec, marginTop: 2 }}>
                      📅 {new Date(al.tarih + 'T00:00:00').toLocaleDateString('tr-TR', { day: '2-digit', month: 'long', year: 'numeric' })}
                      {al.saat && ` · 🕐 ${al.saat.slice(0, 5)}`}
                    </div>
                    {al.notlar && <div style={{ fontSize: 12, color: isDark ? '#999' : '#666', marginTop: 4 }}>{al.notlar}</div>}
                  </div>
                  <button onClick={() => alarmSil(al.id)}
                    style={{ border: 'none', background: 'none', color: isDark ? '#555' : '#ccc', cursor: 'pointer', fontSize: 16, padding: '0 4px', flexShrink: 0 }}
                    title="Sil">×</button>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* Görüşme zaman çizelgesi */}
      <div>
        <div style={{ fontSize: 13, fontWeight: 600, color: textSec, marginBottom: 12 }}>
          Görüşme geçmişi ({gorusmeler.length})
        </div>
        {gorusmeler.length === 0 ? (
          <div style={{ background: card, border: '1px dashed #ddd', borderRadius: 10, padding: '30px 24px', textAlign: 'center', color: textMuted, fontSize: 13 }}>
            Henüz görüşme kaydedilmemiş.
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {gorusmeler.map(g => {
              const kanal = kanalBul(g.kanal);
              return (
                <div key={g.id} style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                  <div style={{ width: 36, height: 36, borderRadius: '50%', background: isDark ? '#222222' : '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, flexShrink: 0, marginTop: 2 }}>
                    {kanal.icon}
                  </div>
                  <div style={{ flex: 1, background: card, border: `1px solid ${border}`, borderRadius: 10, padding: '12px 14px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                      <span style={{ fontSize: 12, fontWeight: 600, color: isDark ? '#bbb' : '#555' }}>{kanal.label}</span>
                      <span style={{ fontSize: 11, color: isDark ? '#555' : '#bbb' }}>{TR(g.olusturuldu)} {SAAT(g.olusturuldu)}</span>
                    </div>
                    <div style={{ fontSize: 13, color: isDark ? '#e0e0e0' : '#333', lineHeight: 1.6, whiteSpace: 'pre-wrap' as const }}>{g.icerik}</div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* WhatsApp Yazışma Paneli */}
      {aday?.tel && (
        <div style={{ background: card, border: `1px solid ${border}`, borderRadius: 12, overflow: 'hidden' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 16px', borderBottom: `1px solid ${border}`, background: isDark ? '#0a1a0a' : '#e9fbe9' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 20 }}>💬</span>
              <span style={{ fontWeight: 600, fontSize: 14, color: isDark ? '#6fcf97' : '#1a7a3c' }}>WhatsApp</span>
              <span style={{ fontSize: 12, color: textMuted }}>+{aday.tel.replace(/\D/g,'')}</span>
            </div>
            {!waYaziliyor && (
              <button onClick={() => { setWaYaziliyor(true); waYukle(); }}
                style={{ fontSize: 12, padding: '5px 12px', borderRadius: 6, border: 'none', background: '#25D366', color: 'white', cursor: 'pointer', fontWeight: 600 }}>
                Yazışmayı Aç
              </button>
            )}
          </div>

          {waYaziliyor && (
            <>
              {/* Mesaj alanı */}
              <div style={{ height: 320, overflowY: 'auto', padding: 16, display: 'flex', flexDirection: 'column', gap: 8, background: isDark ? '#0d1117' : '#f0f0f0' }}>
                {waYukleniyor ? (
                  <div style={{ textAlign: 'center', color: textMuted, fontSize: 13, marginTop: 40 }}>Yükleniyor...</div>
                ) : waMesajlar.length === 0 ? (
                  <div style={{ textAlign: 'center', color: textMuted, fontSize: 13, marginTop: 40 }}>Henüz mesaj yok</div>
                ) : (
                  waMesajlar.map(m => (
                    <div key={m.id} style={{ display: 'flex', justifyContent: m.yon === 'giden' ? 'flex-end' : 'flex-start' }}>
                      <div style={{
                        maxWidth: '72%', padding: '9px 13px', borderRadius: m.yon === 'giden' ? '16px 4px 16px 16px' : '4px 16px 16px 16px',
                        background: m.yon === 'giden' ? '#DCF8C6' : (isDark ? '#1e1e1e' : 'white'),
                        color: isDark && m.yon !== 'giden' ? '#e0e0e0' : '#111',
                        boxShadow: '0 1px 2px rgba(0,0,0,0.12)',
                      }}>
                        {m.yon === 'gelen' && <div style={{ fontSize: 10, fontWeight: 600, color: '#25D366', marginBottom: 3 }}>{m.ad || 'Aday'}</div>}
                        <div style={{ fontSize: 13, lineHeight: 1.5 }}>{m.icerik}</div>
                        <div style={{ fontSize: 10, color: '#aaa', textAlign: 'right', marginTop: 4 }}>
                          {new Date(m.olusturuldu).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}
                          {m.yon === 'giden' && ' ✓✓'}
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>

              {/* Mesaj gönderme */}
              <div style={{ display: 'flex', gap: 8, padding: 12, borderTop: `1px solid ${border}`, background: card }}>
                <textarea
                  value={waMetin}
                  onChange={e => setWaMetin(e.target.value)}
                  onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); waGonder(); } }}
                  placeholder="Mesaj yaz... (Enter ile gönder)"
                  rows={2}
                  style={{ flex: 1, padding: '8px 12px', borderRadius: 8, border: `1px solid ${border}`, fontSize: 13, resize: 'none', background: isDark ? '#111' : '#fafafa', color: isDark ? '#e0e0e0' : '#000', outline: 'none' }}
                />
                <button
                  onClick={waGonder}
                  disabled={!waMetin.trim() || waGonderiliyor}
                  style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: waMetin.trim() ? '#25D366' : '#ccc', color: 'white', cursor: waMetin.trim() ? 'pointer' : 'not-allowed', fontSize: 18 }}>
                  {waGonderiliyor ? '...' : '➤'}
                </button>
              </div>
            </>
          )}
        </div>
      )}

      {/* Düzenle modalı */}
      {duzenleModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200, padding: 16 }}
          onClick={e => { if (e.target === e.currentTarget) setDuzenleModal(false); }}>
          <div style={{ background: card, borderRadius: 12, padding: 24, width: '100%', maxWidth: 460 }}>
            <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 18 }}>Aday bilgilerini düzenle</div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>
              <div><Label>Ad *</Label><input value={form.ad} onChange={e => setForm((p: any) => ({ ...p, ad: e.target.value }))} style={inputSt} /></div>
              <div><Label>Soyad</Label><input value={form.soyad} onChange={e => setForm((p: any) => ({ ...p, soyad: e.target.value }))} style={inputSt} /></div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>
              <div><Label>E-posta</Label><input type="email" value={form.email} onChange={e => setForm((p: any) => ({ ...p, email: e.target.value }))} style={inputSt} /></div>
              <div><Label>Telefon</Label><input value={form.tel} onChange={e => setForm((p: any) => ({ ...p, tel: e.target.value }))} style={inputSt} /></div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10, marginBottom: 10 }}>
              <div>
                <Label>Kaynak</Label>
                <select value={form.kaynak} onChange={e => setForm((p: any) => ({ ...p, kaynak: e.target.value }))} style={selectSt}>
                  {KAYNAKLAR.map(k => <option key={k.key} value={k.key}>{k.label}</option>)}
                </select>
              </div>
              <div>
                <Label>Durum</Label>
                <select value={form.durum} onChange={e => setForm((p: any) => ({ ...p, durum: e.target.value }))} style={selectSt}>
                  {DURUMLAR.map(d => <option key={d.key} value={d.key}>{d.label}</option>)}
                </select>
              </div>
              <div>
                <Label>Cinsiyet</Label>
                <select value={form.cinsiyet||''} onChange={e => setForm((p: any) => ({ ...p, cinsiyet: e.target.value }))} style={selectSt}>
                  <option value=''>—</option>
                  <option value='kadin'>Kadın</option>
                  <option value='erkek'>Erkek</option>
                  <option value='diger'>Diğer</option>
                </select>
              </div>
            </div>
            <div style={{ marginBottom: 10 }}>
              <Label>İlgilendiği sınıf (opsiyonel)</Label>
              <select value={form.ilgilenilen_ders_id||''} onChange={e => setForm((p: any) => ({ ...p, ilgilenilen_ders_id: e.target.value }))} style={selectSt}>
                <option value="">— Seçilmedi —</option>
                {dersOptions.map(d => <option key={d.id} value={d.id}>{d.ad} · {d.seviye}</option>)}
              </select>
            </div>
            <div style={{ marginBottom: 10 }}>
              <Label>İlgi alanı (ek not)</Label>
              <input value={form.ilgi_alani} onChange={e => setForm((p: any) => ({ ...p, ilgi_alani: e.target.value }))} style={inputSt} />
            </div>
            <div style={{ marginBottom: 16 }}>
              <Label>Not</Label>
              <textarea value={form.notlar} onChange={e => setForm((p: any) => ({ ...p, notlar: e.target.value }))} rows={3}
                style={{ ...inputSt, resize: 'vertical' as const }} />
            </div>

            {hata && <div style={{ background: isDark ? 'rgba(228,75,74,0.15)' : '#FCEBEB', color: '#A32D2D', padding: '8px 12px', borderRadius: 6, fontSize: 12, marginBottom: 12 }}>{hata}</div>}
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={() => setDuzenleModal(false)} style={btnSt}>İptal</button>
              <button onClick={duzenleKaydet} disabled={kaydediliyor}
                style={{ ...btnSt, background: '#534AB7', color: 'white', border: 'none' }}>
                {kaydediliyor ? 'Kaydediliyor...' : 'Kaydet'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Alarm modalı */}
      {alarmModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200, padding: 16 }}
          onClick={e => { if (e.target === e.currentTarget) setAlarmModal(false); }}>
          <div style={{ background: card, borderRadius: 12, padding: 24, width: '100%', maxWidth: 400 }}>
            <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 18 }}>🔔 Hatırlatıcı ekle</div>

            <div style={{ marginBottom: 12 }}>
              <Label>Başlık *</Label>
              <input value={alarmForm.baslik} onChange={e => setAlarmForm(p => ({ ...p, baslik: e.target.value }))}
                placeholder="Örn: Tekrar ara, Demo randevusu..." style={inputSt} />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 12 }}>
              <div>
                <Label>Tarih *</Label>
                <input type="date" value={alarmForm.tarih} min={BUGUN}
                  onChange={e => setAlarmForm(p => ({ ...p, tarih: e.target.value }))} style={inputSt} />
              </div>
              <div>
                <Label>Saat (opsiyonel)</Label>
                <input type="time" value={alarmForm.saat}
                  onChange={e => setAlarmForm(p => ({ ...p, saat: e.target.value }))} style={inputSt} />
              </div>
            </div>

            <div style={{ marginBottom: 16 }}>
              <Label>Not (opsiyonel)</Label>
              <textarea value={alarmForm.notlar} onChange={e => setAlarmForm(p => ({ ...p, notlar: e.target.value }))}
                rows={2} placeholder="Hatırlatmak istediğiniz detaylar..."
                style={{ ...inputSt, resize: 'vertical' as const }} />
            </div>

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={() => setAlarmModal(false)} style={btnSt}>İptal</button>
              <button onClick={alarmEkle} disabled={alarmEkleniyor || !alarmForm.tarih || !alarmForm.baslik.trim()}
                style={{ ...btnSt, background: '#534AB7', color: 'white', border: 'none', opacity: (!alarmForm.tarih || !alarmForm.baslik.trim()) ? .5 : 1 }}>
                {alarmEkleniyor ? 'Ekleniyor...' : 'Ekle'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Şubeye Yönlendir Modal */}
      {yonlendirModal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.4)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:300 }}
          onClick={e => { if (e.target === e.currentTarget) setYonlendirModal(false); }}>
          <div style={{ background: card, borderRadius:12, padding:24, width:420 }}>
            <div style={{ fontSize:15, fontWeight:700, marginBottom:4 }}>🔀 Şubeye Yönlendir</div>
            <div style={{ fontSize:12, color: textSec, marginBottom:18 }}>
              <strong>{aday?.ad} {aday?.soyad}</strong> adayını başka bir şubeye aktarın.
              Görüşme geçmişi korunur, otomatik not eklenir.
            </div>

            <div style={{ marginBottom:12 }}>
              <Label>Hedef Şube *</Label>
              <select value={hedefSubeId} onChange={e => setHedefSubeId(e.target.value)} style={selectSt}>
                <option value="">— Şube seçin —</option>
                {subeler.map(s => <option key={s.id} value={s.id}>{s.ad}</option>)}
              </select>
            </div>

            <div style={{ marginBottom:18 }}>
              <Label>Ek not (opsiyonel)</Label>
              <textarea value={yonlendirNot} onChange={e => setYonlendirNot(e.target.value)}
                rows={2} placeholder="Yönlendirme sebebi, özel bilgi..."
                style={{ ...inputSt, resize:'vertical' as const }} />
            </div>

            <div style={{ display:'flex', gap:8, justifyContent:'flex-end' }}>
              <button onClick={() => setYonlendirModal(false)} style={btnSt}>İptal</button>
              <button onClick={yonlendir} disabled={!hedefSubeId || yonlendiriliyor}
                style={{ ...btnSt, background:'#6366F1', color:'white', border:'none', opacity: !hedefSubeId ? .5 : 1 }}>
                {yonlendiriliyor ? 'Yönlendiriliyor...' : 'Yönlendir →'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ─── Mevcut öğrenciyle birleştir modalı ───────────────────────────── */}
      {birlestirModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 400, padding: 16 }}
          onClick={e => { if (e.target === e.currentTarget) setBirlestirModal(false); }}>
          <div style={{ background: card, borderRadius: 14, padding: 24, width: 500, maxWidth: '95vw', maxHeight: '85vh', overflow: 'auto' }}>
            <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 6 }}>Mevcut Öğrenciyle Birleştir</div>
            <div style={{ fontSize: 13, color: textMuted, marginBottom: 16 }}>
              Bu kişinin mobil hesabı (<strong>{aday.email}</strong>) mevcut bir öğrenci kaydıyla birleştirilecek.
            </div>

            <div style={{ background: isDark ? '#111' : '#f8f8ff', border: `1px solid ${isDark ? '#2a2a3a' : '#e0deff'}`, borderRadius: 8, padding: 12, marginBottom: 16 }}>
              <div style={{ fontSize: 11, color: '#534AB7', fontWeight: 600, marginBottom: 4 }}>MOBİL HESAP (CRM kaydı)</div>
              <div style={{ fontWeight: 600 }}>{aday.ad} {aday.soyad}</div>
              <div style={{ fontSize: 12, color: textMuted }}>{aday.email}</div>
            </div>

            <input
              autoFocus
              placeholder="Mevcut öğrenciyi ara (ad, soyad, e-posta)..."
              value={ogrenciArama}
              onChange={e => { setOgrenciArama(e.target.value); ogrenciAra(e.target.value); }}
              style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: `1px solid ${isDark ? '#333' : '#ddd'}`, background: isDark ? '#111' : 'white', color: isDark ? '#fff' : '#000', fontSize: 13, boxSizing: 'border-box' as const, marginBottom: 10 }}
            />

            {aramaYukleniyor && <div style={{ color: textMuted, fontSize: 13, marginBottom: 10 }}>Aranıyor...</div>}

            {ogrencilerSonuc.length > 0 && (
              <div style={{ border: `1px solid ${border}`, borderRadius: 8, overflowY: 'auto', marginBottom: 14, maxHeight: 220 }}>
                {ogrencilerSonuc.map((o: any, i: number) => (
                  <div key={o.id}
                    onClick={() => setSecilenOgrenci(o)}
                    style={{
                      padding: '10px 14px', cursor: 'pointer',
                      background: secilenOgrenci?.id === o.id ? (isDark ? '#1a1a3a' : '#EEEDFE') : (i % 2 === 0 ? card : cardAlt),
                      borderTop: i > 0 ? `1px solid ${border}` : 'none',
                      borderLeft: secilenOgrenci?.id === o.id ? '3px solid #534AB7' : '3px solid transparent',
                    }}>
                    <div style={{ fontWeight: 500, color: secilenOgrenci?.id === o.id ? '#534AB7' : textPrimary }}>
                      {o.ad} {o.soyad}
                    </div>
                    <div style={{ fontSize: 11, color: textMuted }}>{o.email}{o.tel ? ` · ${o.tel}` : ''}</div>
                  </div>
                ))}
              </div>
            )}

            {secilenOgrenci && (
              <div style={{ background: isDark ? '#0a1a0a' : '#eafaf1', border: `1px solid ${isDark ? '#1a3a1a' : '#a3e4b8'}`, borderRadius: 8, padding: 12, marginBottom: 14 }}>
                <div style={{ fontSize: 11, color: '#1D9E75', fontWeight: 600, marginBottom: 4 }}>HEDEF HESAP</div>
                <div style={{ fontWeight: 600 }}>{secilenOgrenci.ad} {secilenOgrenci.soyad}</div>
                <div style={{ fontSize: 12, color: textMuted }}>{secilenOgrenci.email}</div>
                <div style={{ fontSize: 12, color: textSec, marginTop: 6 }}>
                  Mobil hesap bu öğrenciye bağlanacak. Öğrenci artık kendi e-postasıyla giriş yapabilecek.
                </div>
              </div>
            )}

            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 4 }}>
              <button onClick={() => setBirlestirModal(false)} style={{ padding: '9px 18px', borderRadius: 8, border: `1px solid ${border}`, background: 'transparent', cursor: 'pointer', fontSize: 13, color: textPrimary }}>
                İptal
              </button>
              <button
                onClick={birlestirGonder}
                disabled={!secilenOgrenci || birlestirYapiliyor}
                style={{ padding: '9px 18px', borderRadius: 8, border: 'none', background: secilenOgrenci ? '#534AB7' : '#999', color: 'white', cursor: secilenOgrenci ? 'pointer' : 'not-allowed', fontSize: 13, fontWeight: 600 }}>
                {birlestirYapiliyor ? 'İşleniyor...' : '⇌ Birleştir'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function Label({ children }: { children: React.ReactNode }) {
  const { isDark } = useTheme();
  const textSec = isDark ? '#999' : '#888';
  return <div style={{ fontSize: 11, color: textSec, marginBottom: 4, fontWeight: 500 }}>{children}</div>;
}

const inputSt: React.CSSProperties = {
  width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13, boxSizing: 'border-box',
};
const selectSt: React.CSSProperties = {
  width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13,
};
const btnSt: React.CSSProperties = {
  padding: '8px 18px', borderRadius: 6, border: '1px solid #ddd', background: 'white', cursor: 'pointer', fontSize: 13,
};
